var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.897,
    height: 125,
    viewBox: "0 0 81.897 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "padlock",
    transform: "translate(-88.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M114.552,60.345V36.638A28.017,28.017,0,0,1,142.569,8.621h0a28.017,28.017,0,0,1,28.017,28.017V60.345h8.62V36.638A36.638,36.638,0,0,0,142.569,0h0a36.638,36.638,0,0,0-36.638,36.638V60.345Z",
    transform: "translate(-13.345)",
    fill: "#959cb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    "data-name": "Group 1746",
    transform: "translate(92.586 51.724)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 8.621,
    height: 8.621,
    fill: "#7f8499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 8.621,
    height: 8.621,
    transform: "translate(64.655)",
    fill: "#7f8499"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M88.276,238.139v42.027a12.847,12.847,0,0,0,7.442,11.719c9.024,4.115,20.721,6.6,33.507,6.6s24.482-2.484,33.507-6.6a12.847,12.847,0,0,0,7.442-11.719V238.139a8.621,8.621,0,0,0-8.621-8.621H96.9A8.62,8.62,0,0,0,88.276,238.139Z",
    transform: "translate(0 -173.483)",
    fill: "#ffdc64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M237.932,317.586a8.634,8.634,0,0,0-10.688-8.38,8.593,8.593,0,0,0-3.1,15.237,2.017,2.017,0,0,1,.858,1.6v6.4a4.471,4.471,0,0,0,3.586,4.482,4.314,4.314,0,0,0,5.034-4.252V326a1.923,1.923,0,0,1,.823-1.53A8.549,8.549,0,0,0,237.932,317.586Z",
    transform: "translate(-100.087 -233.535)",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747",
    transform: "translate(157.242 62.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M373.992,264.621h0a3.233,3.233,0,0,0,3.232-3.233v-2.155A3.233,3.233,0,0,0,373.992,256h0a3.233,3.233,0,0,0-3.233,3.233v2.155A3.233,3.233,0,0,0,373.992,264.621Z",
    transform: "translate(-370.759 -256)",
    fill: "#fff082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M373.992,326.207h0a3.233,3.233,0,0,0,3.232-3.233V312.2a3.233,3.233,0,0,0-3.232-3.233h0a3.233,3.233,0,0,0-3.233,3.233v10.776A3.233,3.233,0,0,0,373.992,326.207Z",
    transform: "translate(-370.759 -296.035)",
    fill: "#fff082"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M108.454,291.885c-3.125-2.082-5.092-6.7-5.092-11.719V238.139c0-4.761,2.641-8.621,5.9-8.621H96.9a8.621,8.621,0,0,0-8.621,8.621v42.026a12.847,12.847,0,0,0,7.442,11.719c9.024,4.114,20.721,6.6,33.506,6.6.432,0,.851-.025,1.28-.031A41.3,41.3,0,0,1,108.454,291.885Z",
    transform: "translate(0 -173.483)",
    fill: "#ffc850"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.8b62376cbcb0a5fff89e0d6ec77d2e4f.svg";
export { ForwardRef as ReactComponent };